export default function getPageStartEndIndexes(page, pageSize) {
  const start = page * pageSize - pageSize;
  const end = start + pageSize;

  return {
    start,
    end
  };
}
